import defaultForm from "./default_form";

export default {
  default_form: defaultForm,
};
